import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 32"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M27.607 3H5.451c-1.061 0-1.92.838-1.92 1.874V27.12c0 1.036.859 1.879 1.92 1.879h22.156c1.062 0 1.925-.843 1.925-1.874V4.874c0-1.036-.863-1.874-1.925-1.874ZM11.245 25.156H7.386V12.745h3.86v12.41Zm-1.93-14.102a2.236 2.236 0 1 1 0-4.469 2.234 2.234 0 0 1 0 4.469Zm16.373 14.102h-3.855v-6.033c0-1.437-.025-3.29-2.006-3.29-2.005 0-2.31 1.568-2.31 3.188v6.135h-3.85V12.745h3.698v1.696h.05c.513-.975 1.773-2.006 3.646-2.006 3.905 0 4.627 2.57 4.627 5.911v6.81Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }